import React from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import { GET_USER } from "../../GraphQL/Users.js";
import { GET_PLAYER_BY_USER_ID } from "../../GraphQL/Players.js";
import { GET_MANAGER_BY_USER_ID } from "../../GraphQL/Managers.js";
import { GET_COMPETITIONS_BY_USER_ID } from "../../GraphQL/Competitions";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import PlayerButton from "../../Components/Player/PlayerButton.js";
import ManagerButton from "../../Components/Manager/ManagerButton.js";
import CompetitionsTable from "../../Components/Competition/CompetitionsTable.js";
import { Grid, Box, Typography, Card, CardContent } from "@mui/material";

const UserPage = () => {
  const { userId } = useParams();

  const user = useQuery(GET_USER, {
    variables: { id: userId },
  });

  const player = useQuery(GET_PLAYER_BY_USER_ID, {
    variables: { id: userId },
  });

  const manager = useQuery(GET_MANAGER_BY_USER_ID, {
    variables: { userId: userId },
  });

  const competitions = useQuery(GET_COMPETITIONS_BY_USER_ID, {
    variables: { id: userId },
  });

  const queryError =
    user.error || player.error || manager.error || competitions.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          user.refetch();
          player.refetch();
          manager.refetch();
          competitions.refetch();
        }}
      />
    );
  }

  if (user.loading || player.loading || manager.loading || competitions.loading)
    return <LoadingSpinner />;

  return (
    <PageLayout
      title={user.data.user.username}
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Users", to: "/users" },
        { label: user.data.user.username },
      ]}
    >
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
        {player.data.playerByUserId && (
          <PlayerButton playerId={player.data.playerByUserId.id} />
        )}
        {manager.data.managerByUserId && (
          <ManagerButton managerId={manager.data.managerByUserId.id} />
        )}
      </Box>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={8}>
          <Card sx={{ backgroundColor: "#2a3447" }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                Account Details
              </Typography>
              <Grid container spacing={2}>
                {[
                  { label: "Discord ID", value: user.data.user.discordId },
                  { label: "Discriminator", value: user.data.user.discriminator },
                  { label: "Username", value: user.data.user.username },
                  { label: "Icon", value: user.data.user.icon },
                  { label: "Origin ID", value: user.data.user.originId },
                ].map((detail) => (
                  <Grid item xs={12} sm={6} key={detail.label}>
                    <Typography variant="subtitle2" color="text.secondary">
                      {detail.label}
                    </Typography>
                    <Typography variant="body1">
                      {detail.value ?? "-"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>
        Owned Competitions
      </Typography>
      <CompetitionsTable
        competitionsWithPermission={[]}
        competitions={competitions.data.competitionsByUserId}
      />
    </PageLayout>
  );
};

export default UserPage;
